import { loadStatusSkin } from '../../lib/load-status';

/**
 * The saturated status badge (dark ink on a --fi-signal-* fill), keyed on the
 * trucking load_status enum. An unmapped status renders a slate "—" and says so
 * to a screen reader rather than guessing a real state.
 */
export default function LoadStatusBadge({ status }: { status: string | null | undefined }) {
  const skin = loadStatusSkin(status);
  const unknown = skin.label === '—';
  return (
    <span
      data-testid="load-status-badge"
      aria-label={unknown ? 'Status not recognised' : undefined}
      className={`inline-flex w-fit items-center whitespace-nowrap rounded-fi-pill border border-black/20 px-2.5 py-1 text-[0.68rem] font-black uppercase tracking-[0.06em] leading-none text-fi-signal-ink ${skin.fill}`}
    >
      {skin.label}
    </span>
  );
}
